export const METRO_COOKIE_NAME = 'allowedCookieCategories';
export const METRO_COOKIE_VALUE = 'necessary|necessary|functional|performance|promotional|Uncategorized';
